<div id="Initial" class="container-fluid col-lg-11  bg-1">
    <nz-spin [nzSpinning]="isLoading">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12 text-center ">
                    <p></p>
                    <p></p>
                    <p class="" style="font-size: 14px;">
                        This page allows you to add additional functionally that is unique to
                        <ng-container *ngIf="customer">
                            <b><span class="text-style">{{ this.customer.name }}</span></b>
                        </ng-container>
                    </p>
                    <app-video-widget [videoId]="18" style="float: inline-end;"></app-video-widget>

                </div>
            </div>
        </div>
        <br>
        <nz-tabset nzCentered nzSize="large">
            <nz-tab nzTitle="Accounting">
                <div class="container">
                    <div nz-row class="row ring-border">
                        <div nz-col [nzSpan]="12">
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <h6 class="text-style">
                                        Settings
                                    </h6>
                                </div>
                            </div>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <label>
                                        <span>Debtor Account</span>
                                        <nz-radio-group [(ngModel)]="da_mode" style="margin-left: 15px;">
                                            <label nz-radio nzValue="0">single</label>
                                            <label nz-radio nzValue="1">split</label>
                                        </nz-radio-group>
                                       
                                        
                                    </label>
                                    <nz-input-group *ngIf="da_mode == 0" [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Settings.debtorAcc" placeholder="Debtor Account">
                                    </nz-input-group>
                                    <nz-input-group *ngIf="da_mode == 1" [nzPrefix]="prefixTemplateUser">
                                        <div>
                                            <input nz-input [(ngModel)]="Settings.debtorAcc.split(',')[0]" id="soldto" placeholder="Sold-to">
                                            <input style="margin-top: 5px;" nz-input [(ngModel)]="Settings.debtorAcc.split(',')[1]" id="shipto" placeholder="Ship-to">
                                        </div>
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="contacts" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <label>Selling Process</label>
                                    <nz-select [(ngModel)]="Settings.sellingProcess" style="width: 100%;">
                                        <ng-template [ngIf]=" Settings.sellingProcess =='email'">
                                            <nz-option nzLabel="Send Email" nzValue="email"></nz-option>
                                            <nz-option *ngIf="authService.user.isAPI" nzLabel="Insert into POS and Send Email" nzValue="pos"></nz-option>
                                            <nz-option nzLabel="Show Price but Disable Ordering" nzValue="no"></nz-option>
                                            <nz-option nzLabel="Show Stock but not Price" nzValue="soh"></nz-option>
                                        </ng-template>
                                        <ng-template [ngIf]=" Settings.sellingProcess =='pos'">
                                            <nz-option *ngIf="authService.user.isAPI" nzLabel="Insert into POS and Send Email" nzValue="pos"></nz-option>
                                            <nz-option nzLabel="Show Price but Disable Ordering" nzValue="no"></nz-option>
                                            <nz-option nzLabel="Send Email" nzValue="email"></nz-option>
                                            <nz-option nzLabel="Show Stock but not Price" nzValue="soh"></nz-option>
                                        </ng-template>
                                        <ng-template [ngIf]=" Settings.sellingProcess =='soh'">
                                            <nz-option nzLabel="Show Stock but not Price" nzValue="soh"></nz-option>
                                            <nz-option *ngIf="authService.user.isAPI" nzLabel="Insert into POS and Send Email" nzValue="pos"></nz-option>
                                            <nz-option nzLabel="Show Price but Disable Ordering" nzValue="no"></nz-option>
                                            <nz-option nzLabel="Send Email" nzValue="email"></nz-option>
                                        </ng-template>
                                        <ng-template [ngIf]=" Settings.sellingProcess !='email' && Settings.sellingProcess !='soh' && Settings.sellingProcess !='pos' ">
                                            <nz-option nzLabel="Show Price but Disable Ordering" nzValue="no"></nz-option>
                                            <nz-option nzLabel="Show Stock but not Price" nzValue="soh"></nz-option>
                                            <nz-option *ngIf="authService.user.isAPI" nzLabel="Insert into POS and Send Email" nzValue="pos"></nz-option>
                                            <nz-option nzLabel="Send Email" nzValue="email"></nz-option>
                                        </ng-template>
                                    </nz-select>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <label>Credit Limit<span class="text-style"> (ZAR)</span> </label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Settings.creditlimit" type="number" min=0 step=1 placeholder="100">
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="contacts" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <label>Creditor Account</label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Settings.creditorAcc" placeholder="Account No">
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="contacts" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                            </div>
                            <br>
                            <div nz-row nzGutter="24" style="margin-bottom: 16px;">
                                <div nz-col [nzSpan]="8">
                                    <label>Active</label>
                                    <br>
                                    <nz-switch [ngModel]="Settings.activeStatus" (ngModelChange)="change('active')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                    <ng-template #active>
                                        <span nz-icon nzType="check"></span>
                                    </ng-template>
                                    <ng-template #deactive>
                                        <span nz-icon nzType="close"></span>
                                    </ng-template>
                                </div>
                                <div nz-col [nzSpan]="8">
                                    <label>Replenish</label>
                                    <br>
                                    <nz-switch [ngModel]="Settings.replenishStatus" (ngModelChange)="change('replenishment')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                    <ng-template #active>
                                        <span nz-icon nzType="check"></span>
                                    </ng-template>
                                    <ng-template #deactive>
                                        <span nz-icon nzType="close"></span>
                                    </ng-template>
                                </div>
                                <div nz-col [nzSpan]="8">
                                    <label>Credit Check</label>
                                    <br>
                                    <nz-switch [ngModel]="Settings.creditCheck" (ngModelChange)="change('creditCheck')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                    <ng-template #active>
                                        <span nz-icon nzType="check"></span>
                                    </ng-template>
                                    <ng-template #deactive>
                                        <span nz-icon nzType="close"></span>
                                    </ng-template>
                                </div>
                            </div>
                            <div nz-row nzGutter="24" style="margin-bottom: 16px; align-items: flex-end;">
                                <div nz-col [nzSpan]="12">
                                    <label>Credit Application Required</label>
                                    <br>
                                    <nz-switch [(ngModel)]="Settings.isCreditApplicationRequired" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                    <ng-template #active>
                                        <span nz-icon nzType="check"></span>
                                    </ng-template>
                                    <ng-template #deactive>
                                        <span nz-icon nzType="close"></span>
                                    </ng-template>
                                </div>
                                
                            </div>
                            <div nz-row nzGutter="24" [nzJustify]="'space-between'" style="margin-bottom: 16px" *ngIf="Settings.isCreditApplicationRequired">
                                <div nz-col [nzSpan]="15">
                                    <label>Credit Application Link</label>
                                    <div style="display: flex; align-items: center;">
                                        <i nz-icon nzType="credit-card" nzTheme="outline" style="margin-right: 8px;"></i>
                                        <a *ngIf="Settings.creditApplicationLink" [href]="Settings.creditApplicationLink" target="_blank">{{ Settings.creditApplicationLink }}</a>
                                        <span *ngIf="!Settings.creditApplicationLink" class="text-muted">No link provided</span>
                                    </div>
                                </div>
                                <div nz-col>
                                    <label>Credit Application Status</label>
                                    <br>
                                    <nz-radio-group nzButtonStyle="solid" [(ngModel)]="Settings.isCreditApplicationApproved">
                                        <label nz-radio-button [nzValue]="true">Approved</label>
                                        <label nz-radio-button [nzValue]="false">Pending</label>
                                    </nz-radio-group>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <button nz-button nzType="primary" (click)="savesettings()">Save</button>
                                </div>
                            </div>
                        </div>
                        <div nz-col [nzSpan]="12" class="ant-col-spacing">
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <h6 class="text-style">
                                        Add Reciept of Payment
                                    </h6>
                                </div>
                            </div>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <label class="float-left">Document Number</label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Receipt.documentNumber" placeholder="0000">
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <i nz-icon nzType="file" nzTheme="outline"></i>
                                    </ng-template>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <label>Value <small class="text-style">(Vat Incl) </small></label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Receipt.value" placeholder="R 100">
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="sf:moneyBillSVG" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <h6 class="">All <span class="text-style">(Vat Incl)</span> </h6>
                                </div>
                            </div>
                            <br>
                            <nz-spin [nzSpinning]="cred_loading">
                                <div nz-row>
                                    <div nz-col [nzSpan]="12">
                                        <h5>Total Spent</h5>
                                        <h5>Total Paid</h5>
                                        <h5>Account balance</h5>
                                        <h5>Available credit</h5>
                                        <h5 *ngIf="isCreditSyncable">Enforce credit limit</h5>
                                        <h5 *ngIf="isCreditSyncableIQ">Enforce credit limit</h5>
                                    </div>
                                    <div nz-col [nzSpan]="12">
                                        <div style="display:flex"><h5><span class="text-style">R</span> {{ this.totalspent |number }}</h5>
                                            <button *ngIf="isCreditSyncable" (click)="refreshCreditLimit()" nz-button nzType="primary" id="creditReloadBtn" nz-tooltip nzTooltipTitle="Refresh credit limit" nzTooltipPlacement="top"><span  nz-icon nzType="reload"></span></button>
                                            <button *ngIf="isCreditSyncableIQ" (click)="refreshCreditLimitIQ()" nz-button nzType="primary" id="creditReloadBtn" nz-tooltip nzTooltipTitle="Refresh credit limit" nzTooltipPlacement="top"><span  nz-icon nzType="reload"></span></button>
                                        </div>
                                        <h5><span class="text-style">R</span> {{ this.totalpaid |number}}</h5>
                                        <h5><span class="text-style">R</span> 
                                            <span *ngIf="accountBalance == 0;"> {{ this.totalspent - this.totalpaid|number }}</span>
                                            <span *ngIf="accountBalance != 0;" style="color: var(--textcolor)"> {{ accountBalance|number }}</span>
                                        </h5>
                                        <h5><span class="text-style">R</span> 
                                            <span *ngIf="accountBalance ==0;">{{ this.customer.creditlimit +(this.totalpaid-this.totalspent) | number }}</span>
                                            <span *ngIf="accountBalance != 0;" style="color: var(--textcolor)"> {{ this.customer.creditlimit-accountBalance  | number }}</span> 
                                        </h5>
                                        <h5 *ngIf="isCreditSyncable"><span class="text-style">
                                                <nz-switch [(ngModel)]="enforce_credit" (ngModelChange)="changeEnforcement()"></nz-switch>
                                            </span>
                                        </h5>
                                        <h5 *ngIf="isCreditSyncableIQ"><span class="text-style">
                                                <nz-switch [(ngModel)]="enforce_credit" (ngModelChange)="changeEnforcement()"></nz-switch>
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                            </nz-spin>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <button nz-button nzType="primary" (click)="addreciept()">Add</button>
                                </div>
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </nz-tab>
            <nz-tab nzTitle="Pricing">
                <div class="container">
                    <div nz-row class="row ring-border">
                        <div nz-col [nzSpan]="24" class="text-center">
                            <div nz-row>
                                <div nz-col [nzSpan]="12" *ngIf="this.pricelist && this.pricelist">
                                    <label class="float-left">Price List Demand</label>
                                    <nz-select style="width:100%" [(ngModel)]="Pricing.pricelistId">
                                        <nz-option [nzLabel]="'No I will not sell to them'" [nzValue]="0"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.deflt" [nzValue]="15"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plretail" [nzValue]="16"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.wholesale" [nzValue]="17"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plinternal" [nzValue]="14"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plonline" [nzValue]="13"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plcustom1" [nzValue]="10"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plcustom2" [nzValue]="11"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plcustom3" [nzValue]="12"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plcustom4" [nzValue]="19"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plclear" [nzValue]="18"></nz-option>
                                    </nz-select>
                                </div>
                                <div class="ant-col-spacing" nz-col [nzSpan]="12" *ngIf="this.pricelist && this.pricelist">
                                    <label class="float-left">Price List Replenish</label>
                                    <nz-select style="width:100%" [(ngModel)]="Pricing.pricelistId_Repleishment">
                                        <nz-option [nzLabel]="'No I will not sell to them'" [nzValue]="0"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.deflt" [nzValue]="15"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plretail" [nzValue]="16"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.wholesale" [nzValue]="17"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plinternal" [nzValue]="14"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plonline" [nzValue]="13"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plcustom1" [nzValue]="10"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plcustom2" [nzValue]="11"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plcustom3" [nzValue]="12"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plcustom4" [nzValue]="19"></nz-option>
                                        <nz-option [nzLabel]="this.pricelist.plclear" [nzValue]="18"></nz-option>
                                    </nz-select>
                                </div>
                            </div>
                            <div nz-row>
                                <div nz-col [nzSpan]="12">
                                    <label class="float-left">Min Order<span class="text-style"> (Kg or R)</span> </label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Pricing.minOrder" type="number" min=0 step=1 placeholder="100">
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="sf:moneyBillSVG" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                                <div class="ant-col-spacing" nz-col [nzSpan]="12">
                                    <label class="float-left">Min Order Fee<span class="text-style"></span> </label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Pricing.minOrderFee" type="number" min=0 step=1 placeholder="100">
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="sf:moneyBillSVG" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                            </div>
                            <div nz-row *ngIf="authService.user.client_id === 201">
                                <div nz-col [nzSpan]="12">
                                    <label class="float-left">Express Delivery Activated</label>
                                    <nz-select style="width:100%" [(ngModel)]="Pricing.expressDeliveryActive">
                                        <nz-option nzLabel="Yes" [nzValue]="true"></nz-option>
                                        <nz-option nzLabel="No" [nzValue]="false"></nz-option>
                                    </nz-select>
                                </div>
                                <div class="ant-col-spacing" nz-col [nzSpan]="12">
                                    <label class="float-left">Express Delivery Fee<span class="text-style"> (Rands)</span></label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Pricing.expressDeliveryFee" type="number" min=0 step=1 placeholder="100">
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="sf:moneyBillSVG" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                            </div>
                            <div nz-row>
                                <div nz-col [nzSpan]="12">
                                    <label class="float-left">Bulk Discount % <span class="text-style">(Orders of Value greater than R25 000)</span> </label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Pricing.bulkDiscount" type="number" min=0 step=1 placeholder="100"> </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="sf:moneyBillSVG" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                                <div class="ant-col-spacing" nz-col [nzSpan]="12">
                                    <label class="float-left">Super Bulk Discount % <span class="text-style">(Orders of Value greater than R100 000)</span> </label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Pricing.sbulkDiscount" type="number" min=0 step=1 placeholder="100">
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="sf:moneyBillSVG" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <button nz-button nzType="primary" (click)="savepricing()">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nz-tab>
            <nz-tab nzTitle="Logistics">
                <div class="container">
                    <div nz-row class="row ring-border">
                        <div nz-col [nzSpan]="12" nzPush="6" class="text-center">
                            <div nz-row>
                                <div nz-col [nzSpan]="12">
                                    <label class="float-left">Max SOH <span class="text-style"> (to display)</span></label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Logistics.sohMax" type="number" min=0 step=1 placeholder=2>
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="sf:moneyBillSVG" nzTheme="outline"></span>
                                    </ng-template>
                                </div>
                                <div nz-col [nzSpan]="12" class="ant-col-spacing">
                                    <label class="float-left">Delivery Fee <span class="text-style"> (Rands per Tyre)</span> </label>
                                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                                        <input nz-input [(ngModel)]="Logistics.deliveryFee" type="number" min=0 step=1 placeholder="100">
                                    </nz-input-group>
                                    <ng-template #prefixTemplateUser>
                                        <span nz-icon nzType="sf:moneyBillSVG" nzTheme="outline"></span>
                                    </ng-template>                                    
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="12" nzPush="12" class="ant-col-spacing">
                                    <label class="float-left">Enable Custom Delivery Fee</label>
                                    <br>
                                    <nz-switch [(ngModel)]="customer.customDeliveryFee" (ngModelChange)="toggleCustomDeliveryFee()" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                    <ng-template #active>
                                        <span nz-icon nzType="check"></span>
                                    </ng-template>
                                    <ng-template #deactive>
                                        <span nz-icon nzType="close"></span>
                                    </ng-template>

                                </div>
                            </div>
                            <div nz-row *ngIf="customer.customDeliveryFee">
                                <div nz-col nzSpan="24">
                                    <button nz-button nzType="primary" (click)="loadCustomDelveryFeeTable()" style="margin-left: 15px;">
                                        <i nz-icon nzType="table" nzTheme="outline"></i>
                                         Load Table
                                     </button>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <label class="float-left">T&C for Customer<span class="text-style"></span> </label>
                                    <textarea [(ngModel)]="Logistics.termscon" rows="2" class="form-control text-center form-control-custom" placeholder="Terms & Conditions">{{ Logistics.termscon }}</textarea>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="12">
                                    <label class="float-left">SLA</label>
                                    <nz-select [(ngModel)]="Logistics.logisticsSlaId" style="width: 100%;">
                                        <nz-option *ngFor="let item of slaTimes;" [nzLabel]="item.description" [nzValue]="item.logistics_sla_id"></nz-option>
                                    </nz-select>
                                </div>
                                <div nz-col [nzSpan]="12" class="ant-col-spacing">
                                    <label class="float-left">Enable Custom SLA</label><br>
                                    <nz-switch [ngModel]="customer.customSlaActive" (ngModelChange)="toggleCustomSla()" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                    <ng-template #active>
                                        <span nz-icon nzType="check"></span>
                                    </ng-template>
                                    <ng-template #deactive>
                                        <span nz-icon nzType="close"></span>
                                    </ng-template>
                                </div>
                            </div>
                            <br>
                            <div nz-row *ngIf="this.customer.customSlaActive">
                                <div nz-col [nzSpan]="11"><label>Cut Off Time</label></div>
                                <div nz-col [nzSpan]="11"><label>Expected Delivery Time</label></div>
                            </div>
                            <div nz-row *ngIf="this.customer.customSlaActive" [ngStyle]="{'opacity': !this.customer.customSlaActive  ? 0.5 : 1 }">
                                <ng-container *ngFor="let slot of this.SlaSlots;let i=index">
                                    <div nz-col [nzSpan]="11">
                                        <span class="float-left" style="font-size: 0.7rem;color: var(--textcolor);font-style: italic;"> Slot {{i+1}} </span>
                                        <nz-select style="width: 100%;" [(ngModel)]="slot.selectedCuttOffslot" [disabled]="!this.customer.customSlaActive">
                                            <nz-option *ngFor="let cutOff of slot.cutOffTime; let i =index;" [nzLabel]="cutOff" [nzValue]="i"></nz-option>
                                        </nz-select>
                                    </div>
                                    <div nz-col [nzSpan]="11" class="ant-col-spacing">
                                        <span class="float-left" style="font-size: 0.7rem;color: var(--textcolor);font-style: italic;"> Slot {{i+1}} </span>
                                        <nz-select style="width: 100%;" [(ngModel)]="slot.selectedDeliveryslot" [disabled]="!this.customer.customSlaActive">
                                            <nz-option *ngFor="let expectedTime of slot.expectedDelivery; let i =index;" [nzLabel]="expectedTime" [nzValue]="i"></nz-option>
                                        </nz-select>
                                    </div>
                                    <div nz-col [nzSpan]="2">
                                        <span style="float:right; font-size: 0.7rem;color: var(--textcolor);font-style: italic;"> Delete </span>
                                        <button nz-button nzType="primary" nzShape="circle" nzDanger (click)="removeslot(slot)" style="margin-left: 15px;">
                                            <span nz-icon nzType="close" nzTheme="outline"></span>
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                            <br>
                            <div nz-row *ngIf="this.customer.customSlaActive">
                                <div nz-col [nzSpan]="12" [nzPush]="6">
                                    <button nz-button nzType="primary" (click)="addslot()">
                                        <i nz-icon nzType="plus" nzTheme="outline"></i>
                                         Add Slot
                                     </button>
                                </div>
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <button nz-button nzType="primary" (click)="savelogistics()">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nz-tab>
            <nz-tab nzTitle="Information on Order">
                <div class="container">
                    <div nz-row class="row ring-border">
                        <div nz-col [nzSpan]="24" class="text-center">
                            <div nz-row>
                                <div nz-col [nzSpan]="24">
                                    <p class="" style="font-size: 14px;">
                                        Would you like Users to complete some additional information before they submit an order?
                                    </p>
                                </div>
                            </div>
                            <div nz-row>
                                <div nz-col [nzSpan]="12">
                                    <div nz-row>
                                        <div nz-col [nzSpan]="12">
                                            <label class="float-left">Order Reference</label>
                                        </div>
                                        <div nz-col [nzSpan]="12">
                                            <nz-switch [ngModel]="CartDetails.extref" (ngModelChange)="saveordersettings('extref')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                            <ng-template #active>
                                                <span nz-icon nzType="check"></span>
                                            </ng-template>
                                            <ng-template #deactive>
                                                <span nz-icon nzType="close"></span>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                                <div nz-col [nzSpan]="12">
                                    <div nz-row>
                                        <div nz-col [nzSpan]="12">
                                            <label class="float-left">Delivery Info</label>
                                        </div>
                                        <div nz-col [nzSpan]="12">
                                            <nz-switch [ngModel]="CartDetails.deliveryInfo" (ngModelChange)="saveordersettings('deliveryInfo')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                            <ng-template #active>
                                                <span nz-icon nzType="check"></span>
                                            </ng-template>
                                            <ng-template #deactive>
                                                <span nz-icon nzType="close"></span>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div nz-row>
                                <div nz-col [nzSpan]="12">
                                    <div nz-row>
                                        <div nz-col [nzSpan]="12">
                                            <label class="float-left">Salesman's Name</label>
                                        </div>
                                        <div nz-col [nzSpan]="12">
                                            <nz-switch [ngModel]="CartDetails.salesmanName" (ngModelChange)="saveordersettings('salesmanName')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                            <ng-template #active>
                                                <span nz-icon nzType="check"></span>
                                            </ng-template>
                                            <ng-template #deactive>
                                                <span nz-icon nzType="close"></span>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                                <div nz-col [nzSpan]="12">
                                    <div nz-row>
                                        <div nz-col [nzSpan]="12">
                                            <label class="float-left">Vehicle Registration</label>
                                        </div>
                                        <div nz-col [nzSpan]="12">
                                            <nz-switch [ngModel]="CartDetails.vehicleRegistration" (ngModelChange)="saveordersettings('vehicleRegistration')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                            <ng-template #active>
                                                <span nz-icon nzType="check"></span>
                                            </ng-template>
                                            <ng-template #deactive>
                                                <span nz-icon nzType="close"></span>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div nz-row>
                                <div nz-col [nzSpan]="12">
                                    <div nz-row>
                                        <div nz-col [nzSpan]="12">
                                            <label class="float-left">Vehicle Make</label>
                                        </div>
                                        <div nz-col [nzSpan]="12">
                                            <nz-switch [ngModel]="CartDetails.vehicleMake" (ngModelChange)="saveordersettings('vehicleMake')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                            <ng-template #active>
                                                <span nz-icon nzType="check"></span>
                                            </ng-template>
                                            <ng-template #deactive>
                                                <span nz-icon nzType="close"></span>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                                <div nz-col [nzSpan]="12">
                                    <div nz-row>
                                        <div nz-col [nzSpan]="12">
                                            <label class="float-left">Vehicle Milage</label>
                                        </div>
                                        <div nz-col [nzSpan]="12">
                                            <nz-switch [ngModel]="CartDetails.vehicleMilage" (ngModelChange)="saveordersettings('vehicleMilage')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                            <ng-template #active>
                                                <span nz-icon nzType="check"></span>
                                            </ng-template>
                                            <ng-template #deactive>
                                                <span nz-icon nzType="close"></span>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div nz-row>
                                <div nz-col [nzSpan]="12">
                                    <div nz-row>
                                        <div nz-col [nzSpan]="12">
                                            <label class="float-left">Comment Box (Optional)</label>
                                        </div>
                                        <div nz-col [nzSpan]="12">
                                            <nz-switch [ngModel]="CartDetails.commentBox" (ngModelChange)="saveordersettings('commentBox')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                            <ng-template #active>
                                                <span nz-icon nzType="check"></span>
                                            </ng-template>
                                            <ng-template #deactive>
                                                <span nz-icon nzType="close"></span>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                                <div nz-col [nzSpan]="12">
                                    <div nz-row>
                                        <div nz-col [nzSpan]="12">
                                            <label class="float-left">Display Pick Up/Delivery Option</label>
                                        </div>
                                        <div nz-col [nzSpan]="12">
                                            <nz-switch [ngModel]="CartDetails.isDeliveryOptionShowing" (ngModelChange)="saveordersettings('isDeliveryOptionShowing')" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                            <ng-template #active>
                                                <span nz-icon nzType="check"></span>
                                            </ng-template>
                                            <ng-template #deactive>
                                                <span nz-icon nzType="close"></span>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nz-tab>
            <nz-tab nzTitle="Linked Salesmen">
                <div class="container" class="text-center">
                    <div nz-row class="row ring-border">
                        <div nz-col [nzSpan]="24" class="text-center">
                            <p class="" style="font-size: 14px;">
                                Linking a salesmen/user to a client will result in the salesmen receiving an email when the client places an order.
                            </p>
                            <div class="row">
                                <div class="col-lg-12" style="padding-left: 5%;padding-right: 4%;">
                                    <nz-table #usersTable [nzData]="salesmen" [nzFrontPagination]="false" nzSize="small">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Linked</th>
                                            </tr>
                                        </thead>
                                        <tbody class="tbody">
                                            <tr *ngFor="let user of usersTable.data">
                                                <td>{{ user.fullname }}</td>
                                                <td>{{ user.email }}</td>
                                                <td>
                                                    <nz-switch [ngModel]="user.linked" (ngModelChange)="addClientLink(user.user_id,$event)" [nzCheckedChildren]="active" [nzUnCheckedChildren]="deactive"></nz-switch>
                                                    <ng-template #active>
                                                        <span nz-icon nzType="check"></span>
                                                    </ng-template>
                                                    <ng-template #deactive>
                                                        <span nz-icon nzType="close"></span>
                                                    </ng-template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </nz-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nz-tab>
        </nz-tabset>
    </nz-spin>
</div>

<nz-modal
      [(nzVisible)]="isCustomDeliveryFeeVisible"
      nzTitle="Custom Delivery Fee Table"
      (nzOnCancel)="isCustomDeliveryFeeVisible=false"
      (nzOnOk)="isCustomDeliveryFeeVisible=false"
      [nzOkLoading]="isCustomDeliveryFeeLoading"
      nzWidth="1000px"
    >
    <nz-spin [nzSpinning]="isLoadingCustomDeliveryFee" *nzModalContent>
        <ng-container>
            <div nz-row [nzJustify]="'space-evenly'">
                <div nz-col *ngFor="let type of deliveryFees.deliveryFeeTypes;">
                    {{type.name}}
                    <nz-switch [(ngModel)]="type.isActive" (ngModelChange)="changeDeliveryActiveState(type)"></nz-switch>
                </div>
            </div>
            <nz-tabset nzCentered nzSize="large" [(nzSelectedIndex)]="selectedTab">
                <nz-tab [nzTitle]="type.name" *ngFor="let type of filteredDeliveryFeeTypes(); let i = index" (nzClick)="selectedTab = i;">
                    <nz-table #customDeliveryFeeTable [nzData]="filteredDeliveryLines()" [nzFrontPagination]="false" nzSize="small" *ngIf="type.isActive">
                        <thead>
                            <tr>
                                <th>{{type.variableOne}}</th>
                                <th *ngIf="type.variableTwo">{{type.variableTwo}}</th>
                                <th>Custom Delivery Fee</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody class="tbody">
                            <tr *ngFor="let data of customDeliveryFeeTable.data">
                                <td>{{selectedValue(type.deliveryFeeTypeId, data.variableOne)}}</td>
                                <td *ngIf="type.variableTwo">{{selectedValue(type.deliveryFeeTypeId, data.variableTwo)}}</td>
                                <td>
                                    {{data.cost | currency: 'ZAR' : 'symbol-narrow' : '1.2-2'}}
                                </td>
                                <td>
                                    <button nz-button nzType="primary" nzShape="circle" nzDanger (click)="removeDeliveryLine(data)" style="margin-left: 15px;">
                                        <span nz-icon nzType="close" nzTheme="outline"></span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <nz-select style="width: 100%" nzShowSearch="true" [nzPlaceHolder]="'Select ' + type.name" [(ngModel)]="selectedObject.variableOne" (ngModelChange)="setVariableTwoState(type.variableTwo)">
                                        <nz-option *ngFor="let item of filteredSelectionArray(type.deliveryFeeTypeId)" [nzLabel]="item.value" [nzValue]="item.id"></nz-option>
                                    </nz-select>
                                </td>
                                <td *ngIf="type.variableTwo">
                                    <nz-select style="width: 100%" nzShowSearch="true" [nzPlaceHolder]="'Select ' + type.name" [(ngModel)]="selectedObject.variableTwo">
                                        <nz-option *ngFor="let item of filteredSelectionArray(type.deliveryFeeTypeId)" [nzLabel]="item.value" [nzValue]="item.id"></nz-option>
                                    </nz-select>
                                </td>
                                <td>
                                    <input nz-input type="number" min=0 step=0.01 placeholder="100" [(ngModel)]="selectedObject.cost">
                                </td>
                                <td>
                                    <button nz-button nzType="primary" nzShape="circle" (click)="addDeliveryLine(type)" style="margin-left: 15px;">
                                        <span nz-icon nzType="plus" nzTheme="outline"></span>
                                    </button>
                                </td>
                            </tr>
                        </tfoot>
                    </nz-table>
                </nz-tab>
            </nz-tabset>
        </ng-container>
    </nz-spin>

</nz-modal>
